import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import HorizontalWidget from '../HorizontalWidget.vue'; // HorizontalWidget
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../SearchBar.vue'; // Search Bar
let service = new services();

export default {
    name: 'CnproSearch',
    data () {
        return {
            cnpros: [],
            search: {},
            search_result: "",
            search_message: "",
            img_url: service.imageURL,
            img_cp_url: service.imageCNproURL,
            backgroundSize: 'contain',
            pag_intv: service.pageIntv,
            current_page: 0,
            other_cnpros_current_page:0,
            cnprosKey:0,
            cnpros_store:{},
            other_cnpros:[],
            other_cnpros_store:{},
        }
    },
    components: {
        'second-header': SecondHeader,
        'horizontal-widget': HorizontalWidget,
        'main-footer': MainFooter,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        //settings
        isActive(page,view){
            if((view == 'cnpros') && (page == this.current_page)){
                return true;
            }
            if((view == 'othercnpros') && (page == this.other_cnpros_current_page)){
                return true;
            }
        },
        scrollToTop(where){
            //scrolls to the very top
            var top = document.getElementById(where).offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
            //scrolls
        },
        //--//settings

        sortCnpros(offset,page_view){
            this.current_page = page_view;
            let limit = 5;
            // console.log("off"+offset+"limt"+limit)
            this.cnpros = [];//reset
            let count_offset = offset;
            let count_limit = 0;
            if(count_offset <= offset){
                for(let row of this.cnpros_store){
                    if(count_limit < limit){
                        if(this.cnpros_store[count_offset] != undefined){
                            this.cnpros.push(this.cnpros_store[count_offset])
                        }
                    }
                    count_limit++; count_offset++;
                }
            }
            this.current_page = offset;
            this.scrollToTop("topwrap");
            // console.log(this.cnpros)
            // for (i = offset; i < limit; i++) {
            // }
        },

        sortOtherCnpros(offset,page_view){
            this.other_cnpros_current_page = page_view;
            let limit = 5;
            // console.log("off"+offset+"limt"+limit)
            this.other_cnpros = [];//reset
            let count_offset = offset;
            let count_limit = 0;
            if(count_offset <= offset){
                for(let row of this.other_cnpros_store){
                    if(count_limit < limit){
                        if(this.other_cnpros_store[count_offset] != undefined){
                            this.other_cnpros.push(this.other_cnpros_store[count_offset])
                        }
                    }
                    count_limit++; count_offset++;
                }
            }
            this.scrollToTop("otherwrap");
            // console.log(this.cnpros)
            // for (i = offset; i < limit; i++) {
            // }
        },

        prepCnprosPagination(data_count){
            if((data_count % this.pag_intv)){
                // this.cnpros_store.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                this.cnpros_store.count_range = (Math.floor(data_count/this.pag_intv));
            }else{this.cnpros_store.count_range = Math.floor(data_count/this.pag_intv);}
            //  this.current_page = items;
            this.current_page = 1;
        },

        prepOtherCnprosPagination(data_count){
            if((data_count % this.pag_intv)){
                this.other_cnpros_store.count_range = (Math.floor(data_count/this.pag_intv));
            }else{this.other_cnpros_store.count_range = Math.floor(data_count/this.pag_intv);}
            this.other_cnpros_current_page = 1;
        },

        getSearchCnpros(offset,items) {
            var credentials = {
                search_type: 'cnpros',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            }
                // this.search_result = localStorage.getItem("cityneeds_search_keywords");
                this.search_result = this.$route.query.context;
                service.searchCnpros(this, credentials, offset, this.pag_intv).then(function(data) {
                    if(data.body.status == 200) {
                        this.scrollToTop("topwrap");
                        // this.cnpros = data.body.data;
                        this.cnpros_store = data.body.data;
                        this.other_cnpros_store = data.body.data_2;

                        //sort main cnpros
                        this.sortCnpros(0,5);
                        this.prepCnprosPagination(data.body.data_count);
                        //../sort main cnparos

                        //sort other cnpros
                        this.sortOtherCnpros(0,5);
                        this.prepOtherCnprosPagination(data.body.data_2_count);
                            
                        //../sort other cnparos
                    }else if(data.body.status == 400 || data.body.status == 404) {
                        //do something here like redirect to advertised data 
                        this.search_message = "Sorry Could not get the Information of entry yet"; 
                        //work on this regardless  
                        this.other_cnpros_store = data.body.data_2;    
                        //sort other cnpros
                        this.sortOtherCnpros(0,5);
                        this.prepOtherCnprosPagination(data.body.data_2_count);
                        //../work      
                    }
                }).catch((err) => {
                    if(this.cnpros.length == 0) {
                        this.search_message = "Sorry Could not get the Information of entry yet";
                    }
                })
           
        },

        getSearchCnprosXX(offset,items) {
            var credentials = {
                search_type: 'cnpros',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            }
                // this.search_result = localStorage.getItem("cityneeds_search_keywords");
                this.search_result = this.$route.query.context;
                service.searchCnpros(this, credentials, offset, this.pag_intv).then(function(data) {
                    if(data.body.status == 200) {
                        this.cnpros = data.body.data;
                        if((data.body.data_count % this.pag_intv)){
                            this.cnpros.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                        }else{this.cnpros.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                         this.current_page = items;
                    }else if(data.body.status == 400 || data.body.status == 404) {
                        //do something here like redirect to advertised data 
                        this.search_message = "Sorry Could not get the Information of entry yet";            
                    }
                }).catch((err) => {
                    if(err) {
                        this.search_message = "Sorry Could not get the Information of entry yet";
                    }
                })
           
        },

       
    },
    created: function(){
        // this.scrollToTop("topwrap");
        this.getSearchCnpros(0,this.pag_intv);
    }
}


// WEBPACK FOOTER //
// ./src/components/CnproSearch/script.js